<template>
  <div class="area">
    <ul class="select-area clearfix">
      <li
        v-for="(area, index) in selectedArea"
        :key="index"
        class="fl"
        :class="{ current: index === currentSelect }"
        @click="changeIndex(index, area)"
      >
        {{ area.name }}
      </li>
    </ul>
    <ul class="clearfix area-list">
      <li
        v-for="(area, index) in districtList"
        :key="index"
        class="fl"
        :class="{ selected: selectedArea[currentSelect] === area }"
        @click="getArea(area)"
      >
        {{ area.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { sendPost } from '@utils/request';
var url;
export default {
  props: {
    getCityId: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
  },
  data() {
    return {
      currentSelect: 0,
      districtList: [],
      selectedArea: [{ name: this.TLang('请选择', 'address') }],
    };
  },
  async mounted() {
    let res = await this.areaList(this.currentSelect);
    this.districtList = res;
  },
  methods: {
    areaList: async function(index, code) {
      switch (index) {
      case 0:
        url = '/trade/addressContract/getAllDistrict';
        return sendPost({ url }).then(res => res);
      case 1:
        url = '/trade/addressContract/getAllCityByProvince';
        return sendPost({ url, data: { id: code } }).then(res => res);
      case 2:
        url = '/trade/addressContract/getAllRegionByCity';
        return sendPost({ url, data: { id: code } }).then(res => res);
      case 3:
        url = '/trade/addressContract/getAllStreetByRegion';
        return sendPost({ url, data: { id: code } }).then(res => res);
      default:
        return [];
      }
    },
    getArea: async function(area) {
      this.selectedArea.splice(
        this.currentSelect,
        this.selectedArea.length - this.currentSelect,
      );
      this.selectedArea.push(area);
      let res = await this.areaList(this.currentSelect + 1, area.id);
      if (res.length) {
        this.currentSelect++;
        this.districtList = res;
        this.selectedArea.push({ name: this.TLang('请选择', 'address') });
      } else {
        this.getCityId(this.selectedArea);
      }
    },
    changeIndex: async function(index) {
      this.currentSelect = index;
      this.districtList = await this.areaList(
        index,
        this.selectedArea[this.currentSelect === 0 ? 0 : this.currentSelect - 1]
          .id,
      );
    },
  },
};
</script>

<style lang="less" scoped>
.area {
  padding: 0 24px;
  .select-area {
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    flex-wrap: wrap;
    li {
      text-align: center;
      margin-right: 30px;
      &.current {
        color: #3d96e2;
        position: relative;
        &::after {
          content: "";
          display: inline-block;
          position: absolute;
          width: 100%;
          height: 3px;
          background: #3d96e2;
          bottom: 0;
          left: 0;
        }
      }
      &:hover {
        color: #3d96e2;
      }
    }
  }
  .area-list {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    height: 175px;
    overflow: scroll;
    align-content: flex-start;
    li {
      line-height: 24px;
      padding: 0 10px;
      border-radius: 2px;
      margin: 10px 10px 0 0;
      height: 24px;
      &:hover {
        color: #3d96e2;
      }
      &.selected {
        background: #3d96e2;
        color: #fff;
      }
    }
  }
  .area-list::-webkit-scrollbar {
    display: block;
  }
}
</style>
